import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { SpecialtiesPage } from './pages/SpecialtiesPage';
import { SpecialistsPage } from './pages/SpecialistsPage';
import { PatientsPage } from './pages/PatientsPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <LanguageProvider data-id="element-0">
      <Router data-id="element-1">
        <Layout data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
            <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
            <Route path="/services" element={<ServicesPage data-id="element-9" />} data-id="element-8" />
            <Route path="/specialties" element={<SpecialtiesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/specialists" element={<SpecialistsPage data-id="element-13" />} data-id="element-12" />
            <Route path="/patients" element={<PatientsPage data-id="element-15" />} data-id="element-14" />
            <Route path="/contact" element={<ContactPage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </Layout>
      </Router>
    </LanguageProvider>;
}